import actions from './actions';
import { defaults } from '../util';
import migrate from './legacy';
import * as listen from './listen';
import handlers from './handlers';

const defaultOptions = {
  scope: global.document,
  initialData: () => ({})
};

export default class AnalyticsListener {
  constructor(options = {}) {
    this.options = defaults(options, defaultOptions);
  }

  listen(analytics) {
    return new Promise(resolve => {
      const { direct, delegated } = actions(
        handlers(analytics, this.options.initialData)
      );

      migrate(this.options.scope);

      listen.delegated(delegated, this.options.scope);
      listen.directCurrent(direct, this.options.scope);
      listen.listenFuture([...delegated, ...direct], this.options.scope);

      resolve();
    });
  }
}
